import { useEffect, useState, useSyncExternalStore } from "react";
import { createReferenceController } from "./reference-controller";
import type { ReferenceLookupPorts } from "./reference-lookup";

export function useReferenceLookup(
  ports: ReferenceLookupPorts,
  initialAutoplay = true,
) {
  const [controller] = useState(() =>
    createReferenceController(ports, initialAutoplay),
  );
  const state = useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
    controller.getSnapshot,
  );
  useEffect(() => controller.close, [controller]);
  return { state, ...controller };
}
